import { ActionStore } from "higher-order/ActionStore";
import { observable } from "mobx";
import ModalModel from "gradifui/models/ModalModel";

class ProductStore extends ActionStore {

    @observable videoModals = [];

    constructor(props, dispatcher) {
        super(dispatcher);

        for (let i = 0; i < 4; i++) {
            const videoModal = new ModalModel("marketingVideo" + i);
            videoModal.allowScrollBar = false;
            videoModal.hideHeader = true;
            videoModal.shouldCloseOnOverlayClick = true;
            this.videoModals.push(videoModal);
        }
        this.registerModals(this.videoModals);
    }
}

export default ProductStore;
